import React from "react";
import { ReactComponent as GithubIcon } from "../img/icons/gh-icon.svg";
import { ReactComponent as LinkedInIcon } from "../img/icons/linkedin-icon.svg";

function Social() {
  return (
    <div className="social__wrapper">
      <a
        href="https://github.com/etchng"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="icon gh">
          <GithubIcon />
          {/* <i className="fab fa-github" aria-hidden="true"></i> */}
        </div>
      </a>

      <a
        href="https://www.linkedin.com/in/eric-chung-456ab38a/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="icon in">
          <LinkedInIcon />
          {/* <i className="fab fa-linkedin-in" aria-hidden="true"></i> */}
        </div>
      </a>
    </div>
  );
}

export default Social;
